import React, {useState,useEffect} from "react";
import { StyleSheet, Text, View, Button, ImageBackground,Image,Dimensions,TouchableOpacity,TextInput, Alert} from "react-native";
import imgSrc2 from './images/clemgram_black.jpg';
import backk from './images/backk.png';

const Info = (props) => {

		return( 
		           
			<View style={styles.container}>
				<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left'}}>
				
				<Image         
						style={styles.ichart}
						resizeMode={'center'}
						source={imgSrc2}/>
				<Text style={styles.text12}>Clemgram</Text>
				</View>
				<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center'}}>
				
				<Text style={styles.text2}>Terms of Service</Text>
				</View>
				<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:15}}>
				<Text style={styles.text3}>1. Application</Text>
				<Text style={styles.text4}>1.1 Clemgram is a simulated website for laboratory stress and privacy decision-making research. </Text>
				<Text style={styles.text3}>2. Scope of License</Text>
				<Text style={styles.text4}>2.1 You may not reverse engineer, translate, disassemble, integrate, decompile, integrate, remove, modify, combine, create derivative works or updates of, adapt, or attempt to derive the source code of the Clemgram application, or any part thereof. </Text>

				<Text style={styles.text4}>2.2 You may not copy or alter the application or portions thereof. You may create and store copies only on deices that You own or control for backup. You may not remove any intellectual property notices. You acknowledge that no unauthorized third parties may gain access to these copies at any time. </Text>

				<Text style={styles.text4}>2.3 Licensor reserves the right to modify the terms and conditions of the listing. </Text>

				<Text style={styles.text3}>3. Technical Requirements</Text>
				<Text style={styles.text4}>3.1 Licensor attempts to keep the application updated so that it complies with modified/new versions of the firmware and new hardware. You are not granted rights to claim such an update.</Text>

				<Text style={styles.text4}>3.2 You acknowledge that it is Your responsibility to confirm and determine that the website end-user device on which You intend to use the website satisfies the technical specifications mentioned above.</Text>

				<Text style={styles.text3}>4. Maintenance</Text>
				<Text style={styles.text4}>4.1 The licensor’s team is solely responsible for providing any maintenance and support services for this listed application. You can reach the licensor at the email address: yizhou@g.clemson.edu. </Text>
				<Text style={styles.text3}>5. Contribution License</Text>
				<Text style={styles.text4}>You agree that we may access, store, process, and use any information, with the exception of journal entries, that you provide within the application. By submitting suggestions or other feedback regarding the application, you agree that we can use and share such feedback for any purpose without compensation to You. </Text>
				<Text style={styles.text3}>6. Warranty</Text>
				<Text style={styles.text4}>6.1 The Licensor warrants that the application is free of spyware, trojan horses, viruses, or any other malware at the time of Your download. Licensor warrants that the application works as described in the user documentation. </Text>
				<Text style={styles.text3}>7. Legal Compliance</Text>
				<Text style={styles.text4}>You represent and warrant that You are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a “terrorist supporting” country; and that You are not listed in any U.S. Government list of prohibited or restricted parties.  </Text>
				<Text style={styles.text3}>8. Contact Information</Text>
				<Text style={styles.text4}>For general inquiries, complaints, questions, or claims concerning the licensed Application, please contact: </Text>
				<Text style={styles.text4}>Yizhou Liu through email: yizhou@g.clemson.edu. </Text>

				<Text style={styles.text3}>9. Termination</Text>
				<Text style={styles.text4}>The license is valid until terminated by the CADS lab or by You. Your rights under this license will terminate automatically and without notice from the CADS Lab if You fail to adhere to any term(s) of this license. Upon license termination, You shall stop all use of the application, and destroy all copies, full or partial, of the application. </Text>
				
				<Text style={styles.text3}>10. Applicable Law</Text>
				<Text style={styles.text4}>This license agreement is governed by the laws of the State of South Carolina excluding its conflicts of law rules. </Text>
				
				
				
				<Text style={styles.text2}>Privacy Policy </Text>
				<Text style={styles.text4}>Thank you for choosing to be part of our community at the CADS lab. We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about this privacy notice or our practices with regard to personal information, please contact us at yizhou@clemson.edu. </Text>
				
				<Text style={styles.text3}>1.	What information do we collect?</Text>
				<Text style={styles.text4}>We collect your first name, last name, Clemson email address, your profile information on Clemgram, and your responses to the questions appeared on the Clemgram. </Text>

				<Text style={styles.text3}>2.	Will your information be shared with anyone?</Text>
				<Text style={styles.text4}>In short, no. Your information will stay confidential, and only members of the CADS Lab will have access to it. If the situation occurs, government agencies can acquire our data is necessary through warrants. </Text>
				
				<Text style={styles.text3}>3.	Do we use cookies and other tracking technologies?</Text>
				<Text style={styles.text4}>No. </Text>
				
				<Text style={styles.text3}>4.	Is your data transferred internationally?</Text>
				<Text style={styles.text4}>No. </Text>
				
				<Text style={styles.text3}>5.	How long do we keep your information?</Text>
				<Text style={styles.text4}>Information is kept for three years, and then destroyed. </Text>
				
				<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							props.navigation.navigate('Infoo');
							}}>
							<Image         
								style={styles.iedit}
								resizeMode={'center'}
								source={backk}/>
						</TouchableOpacity>
				</View>
				
			</View>
		
		)
}
//	{false}<Text style={styles.text4}>Your Facebook profile is where other people can post their thoughts, opinions, views, or criticisms about you for everyone to see. </Text>
                               
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor:"black",
	},
	button: {
		alignItems: "center",
		backgroundColor: "#DDDDDD",
		padding: 10
	  },
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'center',
        flexDirection: "column",
		justifyContent: "center",
	},
	ichart: {
		height: Dimensions.get('window').height/15,
		width: Dimensions.get('window').width/13,
	  }, 
	  iedit: {
		height: Dimensions.get('window').height/10,
		width: Dimensions.get('window').width/8,
	  }, 
	  ipro: {
		height: Dimensions.get('window').height/3,
		width: Dimensions.get('window').width/3,
	  },
	  ip: {
		height: Dimensions.get('window').height/3,
		width: Dimensions.get('window').width/3,
	  }, 
	  ipost: {
		height: Dimensions.get('window').height/3.5,
		width: Dimensions.get('window').width/3.5,
	  },
	buttonContainer:{
		width: '15%',
		alignSelf: 'center',
		marginTop: 80,
	},
	iweb2: {
		height: Dimensions.get('window').height/2.7,
		width: Dimensions.get('window').width/4,
		marginLeft: 1
	  },
	text: {
		
		fontSize: Dimensions.get('window').width/50,
		color:'#3a9BDC',
		marginRight: 5,
		marginLeft: 5,
	},
    text2: {
		fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text12: {
		//fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
    text4: {
		//fontWeight: "bold",
		fontSize: 25,        
        marginBottom: 15,
		marginRight: 10,
		marginLeft: 10,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text5: {
		fontSize: 16,        
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text6: {
		fontSize: 22, 
		fontWeight: "bold",       
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'blue',
		fontFamily: "sans-serif-condensed",
	},
	image: {
		flex: 1,
		justifyContent: "center"
	  },
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	borderWidth:10,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	text3: {
		fontWeight: "bold",
		fontSize: 30,        
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
		
	},
	  textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:Dimensions.get('window').width/2.5,
		paddingLeft: Dimensions.get('window').width/2.5,
		paddingBottom: 30,
		textAlign: 'center',

	  },
	  textArea: {
		height: 50,
		width:350,
		fontSize: 16,
		borderColor: 'white',
		backgroundColor:'white',
		color:'black',
		borderWidth: 1,
		marginBottom: 20,
		justifyContent: "center"
	  },
	  
	  checkboxContainer: {
		flexDirection: "row",
		
	  },
	  checkbox: {
		alignSelf: "center",
	  },
})
export default Info